import { render } from "./DepartmentsTab.vue?vue&type=template&id=e1da5282"
import script from "./DepartmentsTab.vue?vue&type=script&lang=js"
export * from "./DepartmentsTab.vue?vue&type=script&lang=js"
script.render = render

export default script